import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { QrObraAdminStatus } from "../models/qr-obra-admin-status.model";

@Injectable()
export class QrObraAdminStatusService extends BaseService<QrObraAdminStatus> {

  constructor(public http: HttpClient) {
    super(http);
  }

  /*
  public getListFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }
  */
  public getPathModule(): string {
    return '/qrobras/status';
  }
}